import {
  EditModeNoteWidgetProps,
  ViewModeNoteWidgetProps,
} from '../renderTypes';
import { TrackEvent, WidgetsCommands } from '../../types';
import { ArdoqId, NoteWidgetAttributes, WidgetTypes } from '@ardoq/api-types';
import { isEmpty } from 'lodash';
import { DashboardBuilderNoteWidgetProps } from '../types';
import { Maybe } from '@ardoq/common-helpers';
import { DashboardTrackingEventsNames } from '../../tracking';
import { type I18nLocale, t } from '@ardoq/i18n';

export const getViewModeNoteWidgetProps = ({
  widgetData,
  expandWidget,
}: {
  widgetData: NoteWidgetAttributes;
  expandWidget?: VoidFunction;
}): ViewModeNoteWidgetProps => ({
  _id: widgetData._id,
  layout: widgetData.layout,
  content: widgetData.content,
  hasError: isEmpty(widgetData),
  expandWidget,
});

export const getEditModeNoteWidgetProps = ({
  widgetData: { _id, layout, content, viewValidationErrors },
  commands,
  selectedWidgetId,
  isSaving,
  isInLinkDashboardFiltersMode,
  trackEvent,
  i18nLocale,
}: {
  widgetData: DashboardBuilderNoteWidgetProps;
  isInLinkDashboardFiltersMode: boolean;
  selectedWidgetId: Maybe<ArdoqId>;
  isSaving: boolean;
  trackEvent: TrackEvent;
  commands: WidgetsCommands;
  i18nLocale: I18nLocale;
}): EditModeNoteWidgetProps => ({
  _id,
  layout,
  content,
  hasError: !isEmpty(viewValidationErrors),
  isInLinkDashboardFiltersMode,
  isSelected: _id === selectedWidgetId,
  viewValidationErrors: viewValidationErrors ?? [],
  commands: {
    copyWidget: () => {
      trackEvent(
        DashboardTrackingEventsNames.DUPLICATED_NOTE_IN_DASHBOARD_BUILDER
      );
      commands.copyWidget(_id);
    },
    selectWidget: () => commands.selectWidget(_id),
    deleteWidget: () => {
      trackEvent(
        DashboardTrackingEventsNames.DELETED_CHART_IN_DASHBOARD_BUILDER
      );
      commands.deleteWidget(_id, WidgetTypes.NOTE);
    },
  },
  editButtonTooltipText: t(
    i18nLocale,
    'dashboard:noteWidget.editNote',
    'Edit note'
  ),
  isSaving: isSaving,
});
